export default __webpack_public_path__ + "static/media/logo-icon-dark-blue.0e5b0a0e.svg";